import {
  type UseTransferCardControllerProps,
  useTransferCardController,
} from "./TransferCard.controller";
import { TransferCardPresentation } from "./TransferCard.pres";

export const TransferCard = (props: UseTransferCardControllerProps) => {
  const controller = useTransferCardController(props);

  return <TransferCardPresentation {...controller} />;
};
